import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, isRef as _isRef, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-455832c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mt10 text-right" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 保存")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("一覧へ")

import { ref } from 'vue'
import { PostLogic } from '@/logic/posts/PostLogic'
import { ElMessage } from 'element-plus'
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import BlotFormatter from 'quill-blot-formatter'
import ImageCompress from 'quill-image-compress'
import MagicUrl from 'quill-magic-url'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const toolbar = [
  ['bold', 'italic', 'underline'],
  [{ 'color': [] }, { 'background': [] }],
  ['link'],
  ['image'],
]
const modules = [{
  name: 'blotFormatter',
  module: BlotFormatter,
  options: {/* options */ }
},
{
  name: 'MagicUrl',
  module: MagicUrl,
  options: {/* options */ }
},
{
  name: 'ImageCompress',
  module: ImageCompress,
  options: {
    quality: 0.9,
    maxWidth: 1500,
    maxHeight: 1500,
    imageType: 'image/jpeg',
    debug: false,
    suppressErrorLogging: false, // default
  }
}
]
const quillOptions = {
  debug: 'error'
}

const { addPost, postLoading } = PostLogic();
const new_body = ref('')
const compleate = ref(false)
let bodyEditor: any = ref(null);

const createPost = async () => {
  const body_html = bodyEditor.value.getHTML()
  const size = body_html.length / 1024 / 1024
  // 5MB以上はだめにする
  if (size > 5) {
    ElMessage.error({
      message: '5MBまでになります',
      dangerouslyUseHTMLString: true,
      showClose: true,
      duration: 0
    });
    return
  }

  const ret = await addPost(body_html)
  if (ret == true) {
    compleate.value = true
  }
  new_body.value = ''
  bodyEditor.value.setText("")
}


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_card = _resolveComponent("el-card")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(_component_el_card, null, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", null, "作成しました", 512), [
        [_vShow, compleate.value]
      ]),
      _withDirectives(_createElementVNode("div", null, [
        _createVNode(_unref(QuillEditor), {
          ref: (_value, _refs) => {
            _refs['bodyEditor'] = _value
            _isRef(bodyEditor) ? bodyEditor.value = _value : bodyEditor = _value
          },
          theme: "snow",
          toolbar: toolbar,
          globalOptions: quillOptions,
          modules: modules,
          content: new_body.value,
          "onUpdate:content": _cache[0] || (_cache[0] = ($event: any) => ((new_body).value = $event)),
          contentType: 'html'
        }, null, 8, ["content"]),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: createPost,
            disabled: new_body.value.replace(/<p>|<\/p>|<br>/g, '').length == 0
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ], 512), [
        [_vShow, !compleate.value]
      ]),
      _createVNode(_component_router_link, {
        to: { name: 'Posts', params: { project_id: _ctx.$route.params.project_id } },
        class: "button-link"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, { type: "text" }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _: 1
  }, 512)), [
    [_directive_loading, _unref(postLoading)]
  ])
}
}

})